import { Box, Skeleton } from '@mui/material';
import { ProfilePageHeaderSkeleton } from '../../shared/ProfilePageHeaderSkeleton';
import { profilePageStyles } from '../../styles';

export const ExperiencePageSkeleton: React.FC = () => {
  return (
    <Box>
      <ProfilePageHeaderSkeleton />
      <Box sx={profilePageStyles.profileCard}>
        <Skeleton sx={{ mb: 1.5 }} variant="rectangular" height="2rem" width="15rem" />
        <Skeleton sx={{ mb: 0.5 }} variant="rectangular" height="1.5rem" width="10rem" />
        <Skeleton sx={{ mb: 0.5 }} width="17.5rem" />
        <Box sx={{ mt: 4 }}>
          <Skeleton sx={{ mb: 1.5 }} width="17.5rem" />
          <Skeleton width="100%" />
          <Skeleton width="50%" />
        </Box>
      </Box>
    </Box>
  );
};
